define('lib/view_helpers/planPricingHelper',['require','lib/Podio.Bootstrap'],function(require) {

  var bootstrap = require('lib/Podio.Bootstrap');

  var TierToEcomPlanMap = {
    plus: 'PPLUS001',
    premium: 'PPREM001'
  };

  function getPricingData() {
    var tierPrices = bootstrap.getBootstrapData('TierPrices', true);
    var contract = bootstrap.getBootstrapData('Contract', true);

    if (!tierPrices) {
      return null;
    }

    if (!contract || contract.accounting_provider !== 'new_sfdc') {
      return tierPrices;
    }

    return {
      basic: {
        employee: {
          price: 9,
          list_price: 9
        },
      },
      plus: {
        employee: {
          price: tierPrices[TierToEcomPlanMap.plus]['monthly']['pricePerUser'],
          list_price: tierPrices[TierToEcomPlanMap.plus]['monthly']['pricePerUser']
        }
      },
      premium: {
        employee: {
          price: tierPrices[TierToEcomPlanMap.premium]['monthly']['pricePerUser'],
          list_price: tierPrices[TierToEcomPlanMap.premium]['monthly']['pricePerUser']
        }
      },
      [TierToEcomPlanMap.plus]: tierPrices[TierToEcomPlanMap.plus],
      [TierToEcomPlanMap.premium]: tierPrices[TierToEcomPlanMap.premium]
    };
  }

  return {
    getPricingData: getPricingData,
    TierToEcomPlanMap: TierToEcomPlanMap
  }

});

